import mergeDeep from '../utilities/MergeDeep';
import english from './english.json';
import hindi from './hindi.json';
import kannada from './kannada.json';
import tamil from './tamil.json';
import telugu from './telugu.json';

const translations: any = {
   english,
   hindi,
   kannada,
   tamil,
   telugu,
};

function getTranslation(language: string) {
   const selectedLanguage = translations[language] || {};
   return mergeDeep(english, selectedLanguage);
}

export default getTranslation;
